import React  from "react";
import {SidebarContainer, Icon , CloseIcon,SideBtnWrap
,SidebarLink,SidebarRoute, SidebarWrapper,SidebarMenu} from "./SidebarElements";

const Sidebar = ({isOpen,toggle}) =>{
return(
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
         <CloseIcon/>
    </Icon>
    <SidebarWrapper>
        <SidebarMenu>
            <SidebarLink to="about" onClick={toggle}>About</SidebarLink>
            <SidebarLink to="projects" onClick={toggle}>Projects</SidebarLink>
            <SidebarLink to="contact" onClick={toggle}>Contact</SidebarLink>
            </SidebarMenu>
            <SideBtnWrap>
                <SidebarRoute to="/" onClick={toggle}>Back to top</SidebarRoute>
                </SideBtnWrap>
        </SidebarWrapper>
    </SidebarContainer>
);
};

export default Sidebar;